export default __webpack_public_path__ + "static/media/event_text.1f5e1466.svg";